import { Component, HostBinding, Input } from '@angular/core';
import { PlanType } from '@app/+authenticated/+reports/shared/subscriptions/subscription.model';
import { TimePipe } from '@app/pipes/time.pipe';
import { DepartmentModel } from '@app/reducers/orm/department/department.model';
import { ComplianceViolation } from '@app/reducers/orm/schedule-compliance/schedule-compliance.model';
import { ConflictTopic, ScheduleConflictModel } from '@app/reducers/orm/schedule-conflict/schedule-conflict.model';
import { ScheduleModel } from '@app/reducers/orm/schedule/schedule.model';
import { ShiftModel } from '@app/reducers/orm/shift/shift.model';
import { TeamModel } from '@app/reducers/orm/team/team.model';
import { Dictionary } from '@ngrx/entity';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@sb/ui';
import { clsx } from 'clsx';

@Component({
  selector: 'schedule-item-tooltip',
  standalone: true,
  imports: [TranslateModule, TimePipe, IconComponent],
  templateUrl: './schedule-item-tooltip.component.html',
})
export class ScheduleItemTooltipComponent {
  @HostBinding('class')
  public hostClass = clsx('flex flex-col gap-3');
  @Input()
  public schedule: ScheduleModel;
  @Input()
  public shift: ShiftModel;
  @Input()
  public mode: 'employee' | 'team' = 'employee';
  @Input()
  public isDisabled = false;
  @Input()
  public conflicts: Dictionary<ScheduleConflictModel[]>;
  @Input()
  public violation: ComplianceViolation;
  @Input()
  public scheduledDepartment: DepartmentModel;
  @Input()
  public scheduledTeam: TeamModel;

  protected readonly ConflictTopic = ConflictTopic;
  protected readonly planType = PlanType;
}
